// @flow
export { BankQuestionsCTA } from './BankQuestionsCTA';
